exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* COLOR VARIABLE */\n.transition-wrap {\n  padding: 60px 40px; }\n  .transition-wrap .col-md-4 {\n    color: #747474;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    line-height: normal;\n    font-size: 14px; }\n  .transition-wrap .col-md-4.text-center .fa-circle {\n    color: #0096ff;\n    font-size: 8px;\n    position: relative;\n    top: -2px; }\n  .transition-wrap .col-md-4.text-center .fa-check {\n    color: #0096ff;\n    font-size: 11px;\n    position: relative;\n    top: -1px; }\n\n.trans-history > .warp-breadcrumb nav {\n  width: calc(100% - 100px);\n  float: left; }\n\n.trans-history > .warp-breadcrumb .breadcrumb {\n  border: none; }\n\n.trans-history > .warp-breadcrumb .wrap-filters {\n  float: right; }\n  .trans-history > .warp-breadcrumb .wrap-filters a {\n    font-size: 24px;\n    color: #572f76;\n    display: inline-block;\n    margin: 6px 0 0 20px; }\n\n@media screen and (max-width: 991px) {\n  .transition-wrap.container {\n    width: 100%; }\n    .transition-wrap.container .col-md-4 {\n      width: 33.33%; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/transaction-history/transaction-history.component.scss
// module id = ../../../../../src/app/components/transaction-history/transaction-history.component.scss
// module chunks = main